/**
 * Landing screen: the terminal login, plus referral-code capture from `?code=`.
 *
 * Redirects to the dashboard the moment a wallet is connected — this page has
 * nothing to show a connected user.
 */
import { useWalletConnection } from "@mysten/dapp-kit-react";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { TerminalLogin } from "@/components/TerminalLogin/TerminalLogin";
import { useRoutes } from "@/hooks/useRoutes/useRoutes";
import { storeReferralCode } from "@/lib/referral";

export default function HomePage() {
  // v2: connection state lives on `useWalletConnection()`; `useCurrentWallet()`
  // now returns just the wallet (or null).
  const { isConnected } = useWalletConnection();
  const navigate = useNavigate();
  const routes = useRoutes();

  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (!isConnected) return;

    // `replace` so the back button does not bounce the user straight back to a
    // screen that will immediately redirect again.
    navigate(routes.dashboard.index(), { replace: true });
  }, [isConnected, navigate, routes]);

  useEffect(() => {
    const code = searchParams.get("code");

    if (code === null) return;

    // Ignore malformed codes rather than persisting whatever the link contained.
    storeReferralCode(code);
  }, [searchParams]);

  return <TerminalLogin isReferralCodeSet={true} />;
}
